var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.asset)?_c('asset-states',{attrs:{"asset":_vm.asset,"imei":_vm.asset.reference}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }